import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { ProvidersServices } from '../../services';
import { DeliberyNoteCreateSelectProviderPage } from '../../../delibery_note/delibery-note-create/delibery-note-create-select-provider/delibery-note-create-select-provider';
import * as moment from 'moment';
import { DeliberyNoteViewPage } from '../../../delibery_note/delibery-note-view/delibery-note-view/delibery-note-view';
import { DeliberyNoteServices } from '../../../delibery_note/services';
import { IncomeExpensesListPage } from '../../../income-expenses/income-expenses-list/income-expenses-list';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the DeliberyNoteListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-provider-order-view',
    templateUrl: 'provider-order-view.html',
})
export class ProviderOrderViewPage {
    provider_order: any;
    provider: any;
    list: any;
    deno: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        private alertCtrl: AlertController,
        private providersServices: ProvidersServices,
        private denoServices: DeliberyNoteServices,
        public translate: TranslateService) {
        this.globals.GAtrackView('ProviderOrders', 'ProviderOrders - View', this.globals.restaurant.email, 'View', 'View provider order', 'ProviderOrders', '');

        this.provider_order = this.navParams.get('provider_order');
        this.getData();

    }

    async getData() {
        this.provider = await this.providersServices.getProvider(this.provider_order.uid_provider);
        if (this.provider_order.uid_delibery_note) {
            this.deno = await this.denoServices.getDeno(this.provider_order.uid_delibery_note);
        }

    }

    cancelProviderOrder(provider_order) {

        //ask
        let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-eliminar-pedido'),
            message: this.translate.instant('instant-seguro-quieres-eliminar-pedido'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.globals.GAtrackView('ProviderOrders', 'ProviderOrders - Cancel - Update', this.globals.restaurant.email, 'Create/Update', 'Update cancel order provider', 'ProviderOrders', this.provider.email);
                        this.providersServices.afs.collection('provider_order').doc(provider_order.UID).update({
                            'state': 'cancelled',
                        }).then(doc => {
                            this.provider_order.state = 'cancelled';
                        });
                    }
                }
            ]
        });
        alert.present();
    }

    createDeliberyNoteFromOrder(provider_order) {
        //cridar a alabaran per crear
        this.navCtrl.push(DeliberyNoteCreateSelectProviderPage, {
            provider_static: provider_order.uid_provider + ',;,' + provider_order.provider_static,
            date: moment().format("YYYY-MM-DD"),
            number: '',
            origin: 'provider_order',
            list: provider_order.list,
            uid_provider_order: provider_order.UID
        });

    }

    openDeliberyNoteView(provider_order) {
        this.navCtrl.push(DeliberyNoteViewPage, {
            delibery_note_uid: provider_order.uid_delibery_note,
        });
    }

    openIE() {
        this.globals.side_menu_active = 'inexp';
        this.navCtrl.push(IncomeExpensesListPage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/providers/orders/provider-order-view/provider-order-view.ts